function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 359.346,
  y: 323.512,
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -126.6671 364.829)",
  width: 35.417,
  height: 23.607
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 317.608,
  y: 365.247,
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -168.4038 347.5395)",
  width: 35.416,
  height: 23.607
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 409.434,
  y: 373.576,
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -147.3977 414.9103)",
  width: 35.417,
  height: 23.607
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 367.696,
  y: 415.334,
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -189.1502 397.6272)",
  width: 35.416,
  height: 23.607
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 384.391,
  y: 348.543,
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -137.032 389.8698)",
  width: 35.416,
  height: 23.607
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 342.652,
  y: 390.291,
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -178.777 372.5833)",
  width: 35.416,
  height: 23.607
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 333.994,
  y: 118.967,
  transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 558.3055 492.7982)",
  width: 94.441,
  height: 23.607
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 317.609,
  y: 123.137,
  transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 477.0044 467.464)",
  width: 35.417,
  height: 23.607
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 359.337,
  y: 164.879,
  transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 518.7222 568.2271)",
  width: 35.416,
  height: 23.607
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 367.672,
  y: 73.062,
  transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 597.8773 417.3795)",
  width: 35.417,
  height: 23.607
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 409.423,
  y: 114.792,
  transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 639.6409 518.1393)",
  width: 35.416,
  height: 23.607
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 58.512,
  y: 394.466,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 318.2447 44.2295)",
  width: 94.441,
  height: 23.607
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 133.929,
  y: 390.285,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 328.7331 10.545)",
  width: 35.417,
  height: 23.607
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 92.197,
  y: 348.548,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 286.9978 27.8293)",
  width: 35.418,
  height: 23.607
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 108.603,
  y: 344.383,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 297.5015 -5.8596)",
  width: 94.441,
  height: 23.607
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  x: 58.513,
  y: 93.932,
  transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 255.2646 105.7379)",
  width: 94.441,
  height: 23.607
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  x: 83.553,
  y: 118.979,
  transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 315.7209 130.7894)",
  width: 94.441,
  height: 23.607
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  x: 108.596,
  y: 144.022,
  transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 376.1802 155.8332)",
  width: 94.441,
  height: 23.607
});

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

var _ref22 = /*#__PURE__*/React.createElement("g", null);

var _ref23 = /*#__PURE__*/React.createElement("g", null);

var _ref24 = /*#__PURE__*/React.createElement("g", null);

var _ref25 = /*#__PURE__*/React.createElement("g", null);

var _ref26 = /*#__PURE__*/React.createElement("g", null);

var _ref27 = /*#__PURE__*/React.createElement("g", null);

var _ref28 = /*#__PURE__*/React.createElement("g", null);

var _ref29 = /*#__PURE__*/React.createElement("g", null);

var _ref30 = /*#__PURE__*/React.createElement("g", null);

var _ref31 = /*#__PURE__*/React.createElement("g", null);

var _ref32 = /*#__PURE__*/React.createElement("g", null);

var _ref33 = /*#__PURE__*/React.createElement("g", null);

var _ref34 = /*#__PURE__*/React.createElement("g", null);

function Svg055SouthKorea(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M350.445,256c0,23.611-42.285,82.639-94.445,82.639S161.555,279.611,161.555,256  c0-52.161,42.285-94.445,94.445-94.445S350.445,203.839,350.445,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M350.445,256c0,52.161-42.285,94.445-94.445,94.445S161.555,308.161,161.555,256"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg055SouthKorea);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };